export const LOGGED_IN_STATE = 'LOGGED_IN';
export const DEFAULT_PROMO = 'R30';
export const TOPICS = {
  REGISTRATION_START: 'wh.common.command.ui.registration.flow.start',
  LOGIN_START: 'wh.common.command.ui.login.flow.start',
  SESSION_STATE_GET: 'wh.common.event.session.state.get',
  AA_DEPOSIT_START: 'action.deposit.start',
  AA_REGISTRATION_START: 'action.account.registration.start',
  AA_ACCOUNT_RECOVERY: 'action.account.recovery.start',
  AA_ACCOUNT_REOPEN: 'action.account.reopen.start',
  AA_PASSWORD_RESET: 'action.account.password.reset.start',
  AA_LOGIN_START: 'action.account.login.start',
  AA_DCF: 'action.dcf.start',
  AA_HARD_FLAG: 'action.account.hard.flag.start',
  AA_SOFT_FLAG: 'action.account.soft.flag.start',
  AA_FAQ_PAGE_OPEN: 'action.account.faq.page.open',
};
